import React, { useEffect, useRef } from 'react';
import * as am4charts from '@amcharts/amcharts4/charts';
import styled from 'styled-components';
import { setupChart } from 'features/schools/services/am4charts';
import { ChartData } from 'features/schools/services/models';

const AxisTitle = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: rgba(9, 21, 38, 0.6);
`;

interface Props {
  yTitle: string;
  showTotal?: boolean;
  data: ChartData[];
}

const Component = ({ yTitle, data, showTotal }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const chart = useRef<am4charts.XYChart>();

  useEffect(() => {
    if (chart.current) {
      chart.current?.dispose();
      chart.current = undefined;
    }

    chart.current = setupChart(ref.current!, data, showTotal);

    return () => {
      chart.current!.dispose();
    };
  }, [showTotal, data]);

  return (
    <>
      <AxisTitle>{yTitle}</AxisTitle>
      <div ref={ref} style={{ width: '100%', height: '397px' }} />
    </>
  );
};

export default Component;
